import instanceAxios from '../config/api'
import { Action } from '../types/actionTypes'
import {
  ActionPriorityRatio,
  ActionsByMission,
  calculateCriticalBudgetRatio,
  calculateCriticalCompletedProjectsRatio,
  calculateOverdueProjectRatio,
  calculateProjectTypeBudgetRatios,
  countAppRelatedIncidentsRatio,
  countCriticalApplicationIncidentsRatioType,
  countCriticalNetworkIncidentsRatio,
  countIncidentsByTypeForMission,
  countIncidentsCriticalOrHighRatioByMission,
  countIncidentsWithPerimeterNetworkRatio,
  countIncidentsWithPerimeterServerRatio,
  countIncidentsWithSlaUnder24Ratio,
  countProject,
  CriticalServerIncidentsRatioType,
  Mission,
  MissionResponse,
  ProjectCountsByPriorityAndStatus,
  projectCountsByTypeAndStatus,
  projectPriority,
  projectPriorityCriticalRatio,
  projectPriorityHighRatio,
  ProjectsBudgetTable,
  VulnerabilityDistribution,
} from '../types/missionTypes'
const API_URL = '/missions'

export const getAllMissions = async ({
  search,
  page,
  pageSize,
}: {
  search?: string
  page?: number
  pageSize?: number
}) => {
  try {
    const response = await instanceAxios.get<MissionResponse>(`${API_URL}`, {
      params: {
        search,
        page,
        pageSize,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch missions.')
  }
}

export const SearchApi = async ({
  query,
  field,
}: {
  query?: string
  field?: string
}) => {
  try {
    const response = await instanceAxios.get<Mission[]>(`${API_URL}/search`, {
      params: {
        query,
        field,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch missions.')
  }
}
export const getActionsWithoutProjectByMissionId = async (
  missionId: string
) => {
  try {
    const response = await instanceAxios.get<{
      message: string
      actions: Action[]
    }>(`${API_URL}/getActionsWithoutProject/${missionId}`)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch actions without project.')
  }
}
export const deleteMissionApi = async (id: string) => {
  try {
    const response = await instanceAxios.delete<Mission[]>(`${API_URL}/` + id)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch missions.')
  }
}

export const getMissionbyIdApi = async (MissionId: string) => {
  try {
    const response = await instanceAxios.get<Mission>(`${API_URL}/` + MissionId)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch mission.')
  }
}

export const addMissionApi = async (newMission: Mission): Promise<Mission> => {
  try {
    const response = await instanceAxios.post<Mission>(
      `${API_URL}/`,
      newMission
    )
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add mission.')
  }
}

export const updateMissionApi = async (
  updatedMission: Mission,
  _id: string
): Promise<Mission> => {
  try {
    const response = await instanceAxios.put<Mission>(
      `${API_URL}/${_id}`,
      updatedMission
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUT mission.')
  }
}

export const getProjectPriorityCriticalHighRatioeApi = async (
  idMission: string
): Promise<projectPriorityCriticalRatio> => {
  try {
    const response = await instanceAxios.get<projectPriorityCriticalRatio>(
      `missions/projectPriorityCriticalRatio/${idMission}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to project Priority CriticalRatio')
  }
}

export const getProjectPriorityHighRatioApi = async (
  idMission: string
): Promise<projectPriorityHighRatio> => {
  try {
    const response = await instanceAxios.get<projectPriorityHighRatio>(
      `missions/projectPriorityHighRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to project Priority High Ratio')
  }
}

export const getprojectPriorityCriticalRatioApi = async (
  idMission: string
): Promise<projectPriority> => {
  try {
    const response = await instanceAxios.get<projectPriority>(
      `missions/projectPriorityCriticalRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to project Priority Critical Ratio')
  }
}

export const getProjectCountsByPriorityApi = async (
  idMission: string
): Promise<countProject> => {
  try {
    const response = await instanceAxios.get<countProject>(
      `missions/projetCountsByPriority/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Project Counts By Priority')
  }
}

export const getProjectCountsByPriorityAndStatusApi = async (
  idMission: string
): Promise<ProjectCountsByPriorityAndStatus> => {
  try {
    const response = await instanceAxios.get<ProjectCountsByPriorityAndStatus>(
      `missions/projectCountsByPriorityAndStatus/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Project Counts By PriorityAndStatus')
  }
}

export const getProjectCountsByTypeAndStatusApi = async (
  idMission: string
): Promise<projectCountsByTypeAndStatus> => {
  try {
    const response = await instanceAxios.get<projectCountsByTypeAndStatus>(
      `missions/projectCountsByTypeAndStatus/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to Project Counts By TypeAndStatus')
  }
}

export const getProjectsBudgetTableApi = async (
  idMission: string
): Promise<ProjectsBudgetTable> => {
  try {
    const response = await instanceAxios.get<ProjectsBudgetTable>(
      `missions/getProjectsBudgetTable/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to ProjectsBudgetTable')
  }
}

export const calculateCriticalBudgetRatioByMissionIdApi = async (
  idMission: string
): Promise<calculateCriticalBudgetRatio> => {
  try {
    const response = await instanceAxios.get<calculateCriticalBudgetRatio>(
      `missions/calculateCriticalBudgetRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error(
      'Failed to calculate Critical Budget Ratio Projects BudgetTable'
    )
  }
}

export const calculateProjectTypeBudgetRatiosApi = async (
  idMission: string
): Promise<calculateProjectTypeBudgetRatios> => {
  try {
    const response = await instanceAxios.get<calculateProjectTypeBudgetRatios>(
      `missions/calculateProjectTypeBudgetRatios/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Project Type Budget Ratios')
  }
}

export const calculateCriticalCompletedProjectsRatioApi = async (
  idMission: string
): Promise<calculateCriticalCompletedProjectsRatio> => {
  try {
    const response =
      await instanceAxios.get<calculateCriticalCompletedProjectsRatio>(
        `missions/calculateCriticalCompletedProjectRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Critical Completed Projects Ratio')
  }
}

export const calculateOverdueProjectRatioApi = async (
  idMission: string
): Promise<calculateOverdueProjectRatio> => {
  try {
    const response = await instanceAxios.get<calculateOverdueProjectRatio>(
      `missions/calculateOverdueProjectRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculateOverdueProjectRatio')
  }
}

export const countIncidentsCriticalOrHighRatioByMissionApi = async (
  idMission: string
): Promise<countIncidentsCriticalOrHighRatioByMission> => {
  try {
    const response =
      await instanceAxios.get<countIncidentsCriticalOrHighRatioByMission>(
        `missions/countIncidentsCriticalOrHighRatioByMission/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Incidents Critical OrHigh Ratio ByMission')
  }
}

export const countIncidentsByTypeForMissionApi = async (
  idMission: string
): Promise<countIncidentsByTypeForMission> => {
  try {
    const response = await instanceAxios.get<countIncidentsByTypeForMission>(
      `missions/countIncidentsByTypeForMission/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Incidents By Type For Mission')
  }
}

export const countIncidentsWithSlaUnder24RatioApi = async (
  idMission: string
): Promise<countIncidentsWithSlaUnder24Ratio> => {
  try {
    const response = await instanceAxios.get<countIncidentsWithSlaUnder24Ratio>(
      `missions/countIncidentsWithSlaUnder24Ratio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Incidents By Type For Mission')
  }
}

export const countIncidentsWithPerimeterNetworkRatioApi = async (
  idMission: string
): Promise<countIncidentsWithPerimeterNetworkRatio> => {
  try {
    const response =
      await instanceAxios.get<countIncidentsWithPerimeterNetworkRatio>(
        `missions/countIncidentsWithPerimeterNetworkRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Incidents With Perimeter Network Ratio')
  }
}

export const countIncidentsWithPerimeterServerApi = async (
  idMission: string
): Promise<countIncidentsWithPerimeterServerRatio> => {
  try {
    const response =
      await instanceAxios.get<countIncidentsWithPerimeterServerRatio>(
        `missions/countIncidentsWithPerimeterServerRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Incidents With Perimeter Server Ratio')
  }
}

export const countCriticalNetworkIncidentsRatioApi = async (
  idMission: string
): Promise<countCriticalNetworkIncidentsRatio> => {
  try {
    const response =
      await instanceAxios.get<countCriticalNetworkIncidentsRatio>(
        `missions/countCriticalNetworkIncidentsRatio/${idMission}`
      )
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Network Incidents Ratio')
  }
}

export const CriticalServerIncidentsRatioApi = async (
  idMission: string
): Promise<CriticalServerIncidentsRatioType> => {
  try {
    const response = await instanceAxios.get<CriticalServerIncidentsRatioType>(
      `missions/CriticalServerIncidentsRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Server Incidents Ratio')
  }
}

export const countCriticalApplicationIncidentsRatioApi = async (
  idMission: string
): Promise<countCriticalApplicationIncidentsRatioType> => {
  try {
    const response =
      await instanceAxios.get<countCriticalApplicationIncidentsRatioType>(
        `missions/countCriticalApplicationIncidentsRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Application Incidents Ratio')
  }
}

export const countCriticalDMZIncidentsRatioApi = async (
  idMission: string
): Promise<countCriticalApplicationIncidentsRatioType> => {
  try {
    const response =
      await instanceAxios.get<countCriticalApplicationIncidentsRatioType>(
        `missions/countCriticalDMZIncidentsRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Application Incidents Ratio')
  }
}
export const countCriticalPcIncidentsRatioApi = async (
  idMission: string
): Promise<countCriticalApplicationIncidentsRatioType> => {
  try {
    const response =
      await instanceAxios.get<countCriticalApplicationIncidentsRatioType>(
        `missions/countCriticalPcIncidentsRatio/${idMission}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Application Incidents Ratio')
  }
}

export const countAppRelatedIncidentsRatioApi = async (
  idMission: string
): Promise<countAppRelatedIncidentsRatio> => {
  try {
    const response = await instanceAxios.get<countAppRelatedIncidentsRatio>(
      `missions/countAppRelatedIncidentsRatio/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Network Incidents Ratio')
  }
}
export const getVulnerabilityDistributionByMissionIdApi = async (
  idMission: string
): Promise<VulnerabilityDistribution> => {
  try {
    const response = await instanceAxios.get<VulnerabilityDistribution>(
      `missions/getVulnerabilityDistributionByMissionId/${idMission}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Network Incidents Ratio')
  }
}
export const getActionPriorityCriticalRatioApi = async (
  id: string
): Promise<ActionPriorityRatio> => {
  try {
    const response = await instanceAxios.get<ActionPriorityRatio>(
      `${API_URL}/actionPriorityCriticalRatio/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch critical priority ratio.')
  }
}

export const getActionPriorityHighRatioApi = async (
  id: string
): Promise<ActionPriorityRatio> => {
  try {
    const response = await instanceAxios.get<ActionPriorityRatio>(
      `${API_URL}/actionPriorityHighRatio/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch high priority ratio.')
  }
}

export const getActionPriorityMediumRatioApi = async (
  id: string
): Promise<ActionPriorityRatio> => {
  try {
    const response = await instanceAxios.get<ActionPriorityRatio>(
      `${API_URL}/actionPriorityMediumRatio/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch medium priority ratio.')
  }
}

export const getActionPriorityLowRatioApi = async (
  id: string
): Promise<ActionPriorityRatio> => {
  try {
    const response = await instanceAxios.get<ActionPriorityRatio>(
      `${API_URL}/actionPriorityLowRatio/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch low priority ratio.')
  }
}
export const getCriticalActionsByMissionIdApi = async (
  id: string
): Promise<ActionsByMission> => {
  try {
    const response = await instanceAxios.get<ActionsByMission>(
      `${API_URL}/criticalActionsByMissionId/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch critical actions.')
  }
}

export const getHighActionsByMissionIdApi = async (
  id: string
): Promise<ActionsByMission> => {
  try {
    const response = await instanceAxios.get<ActionsByMission>(
      `${API_URL}/highActionsByMissionId/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch high actions.')
  }
}

export const getMediumActionsByMissionIdApi = async (
  id: string
): Promise<ActionsByMission> => {
  try {
    const response = await instanceAxios.get<ActionsByMission>(
      `${API_URL}/meduimActionsByMissionId/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch medium actions.')
  }
}

export const getLowActionsByMissionIdApi = async (
  id: string
): Promise<ActionsByMission> => {
  try {
    const response = await instanceAxios.get<ActionsByMission>(
      `${API_URL}/lowActionsByMissionId/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch low actions.')
  }
}
